interface IGOALPLANNER_FORMULA {
  financialGoal: number;
  existingInvestment: number;
  noOfYears: number;
  expectedInflation: number;
  expectedRoi: number;
}

export const GOALPLANNER_FORMULA = ({
  financialGoal,
  existingInvestment,
  noOfYears,
  expectedInflation,
  expectedRoi,
}: IGOALPLANNER_FORMULA) => {
  const goal = Number(financialGoal);
  const existingInvest = Number(existingInvestment);
  const duration = Number(noOfYears);
  const expectInflation = Number(expectedInflation);
  const expectRoi = Number(expectedRoi);
  if (
    goal < 0 ||
    goal > 2e7 ||
    existingInvest < 0 ||
    existingInvest > 1e7 ||
    duration < 0 ||
    duration > 35 ||
    expectInflation < 2 ||
    expectInflation > 9 ||
    expectRoi < 1 ||
    expectRoi > 20
  ) {
    const res = 0;
    return {
      futureValueGoal: res,
      futureValueInvestment: res,
      monthlyInvestment: res,
    };
  }
  const futureGoal = Math.round(
    goal * Math.pow(1 + expectInflation / 100, duration)
  );
  const futureInvest = Math.round(
    existingInvest * Math.pow(1 + expectRoi / 100, duration)
  );
  const futureDiff = -(futureGoal - futureInvest);
  const rate = expectRoi / 100 / 12;
  const term = Math.pow(1 + expectRoi / 100 / 12, duration * 12);
  const result = Math.round((-futureDiff * rate) / (term - 1));
  return {
    futureValueGoal: futureGoal,
    futureValueInvestment: futureInvest,
    monthlyInvestment: result,
  };
};
